import React, { useState, useCallback, useEffect } from "react";
import "./css/index.css";
import FilterCheck from "../../components/FilterCheck/FilterCheck";
import PostListSection from "../../components/PostListSection/PostListSection";
import { officeApi } from "../../api/config";

const Report = () => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [type, settype] = useState<number | undefined>(undefined);
  const [data, setData] = useState([]);
  const [search, setsearch] = useState<string>("");
  const onSearch = useCallback((e: string) => {
    setsearch(e);
  }, []);

  const getReport = useCallback(() => {
    officeApi("/web/cmnt/findAlertCtts").then(
      ({
        data: {
          sts_fg,
          succ_obj: { list },
        },
      }) => {
        setData(list);
      }
    );
  }, []);

  const ReportBlind = useCallback(
    (id: string, sts: string) => {
      officeApi
        .post("/cstm/alert", {
          alert_id: id,
          alert_sts_cd: sts,
        })
        .then(({ data }) => {
          if (data) {
            getReport();
          }
        });
    },
    [getReport]
  );

  useEffect(() => {
    getReport();
    return () => {};
  }, [getReport]);

  // const __searchInit = useCallback(() => {
  //   let clone = box.slice();
  //   if (search) {
  //     setData(
  //       clone.filter(({ declarationUser }) => declarationUser.includes(search))
  //     );
  //   } else {
  //     setData(clone);
  //   }
  // }, [search, type]);

  // const __changeFilter = useCallback(
  //   (e: string) => {
  //     let clone = box.slice();
  //     setData(clone.filter((item) => item.declarationType === e));
  //     settype(e);
  //   },
  //   [data]
  // );

  // const __checkFilter = useCallback(
  //   (e: string) => {
  //     let clone = box.slice();
  //     setData(clone.filter((item) => item.declarationLocation === e));
  //     settype(e);
  //   },
  //   [data]
  // );

  return (
    <main className="report-page">
      <div className="wrapper">
        <div className="report-title">신고관리</div>
        <div className="filter-box">
          <FilterCheck FillterType="type" />

          <div className="report-category">
            <div className="category-wrapper">
              <div className="title">신고사유</div>
              <div className="category">
                {" "}
                <div className={`type_box ${isOpen ? "open" : ""}`}>
                  <button
                    className="now"
                    onClick={() => {
                      setIsOpen(!isOpen);
                    }}
                  >
                    <div className="type">
                      {type ? report_layouts[type].title : "선택"}
                    </div>
                    <img
                      className="buttontype"
                      src="/assets/common/button.svg"
                    ></img>
                  </button>
                  {report_layouts.map((item, idx) => {
                    return (
                      <button
                        key={idx}
                        onClick={() => {
                          settype(idx);
                          setIsOpen(false);
                        }}
                      >
                        {item.title}
                      </button>
                    );
                  })}
                </div>
              </div>
            </div>
            <div className="search-wrapper">
              <div className="title">검색</div>
              <form
                className="search"
                onSubmit={(e) => {
                  // __searchInit();
                  e.preventDefault();
                }}
              >
                <input
                  placeholder="검색어 입력"
                  type="text"
                  onChange={(e) => {
                    onSearch(e.target.value);
                  }}
                />
              </form>
            </div>
          </div>
          <FilterCheck FillterType="report" />
          <button className="search-btn" onClick={() => {}}>
            검색
          </button>
        </div>
        <div className="report-list">
          신고 건 수 <span>{data.length}</span>
        </div>
        <PostListSection
          type="report"
          data={data}
          tags={tagLayouts}
          PostRemove={ReportBlind}
          ProjectPause={undefined}
          category={undefined}
          ChangeProjectSts={undefined}
          __ChangeState={undefined}
          prjtData={undefined}
        />
      </div>
    </main>
  );
};

export default Report;
const tagLayouts = [
  {
    title: "번호",
    type: "report-number",
  },
  {
    title: "신고자",
    type: "report-user",
  },
  {
    title: "신고위치",
    type: "report-declarationLocation",
  },
  {
    title: "신고대상",
    type: "report-declarationUser",
  },
  {
    title: "신고대상본문",
    type: "report-declaration",
  },
  {
    title: "신고사유 ",
    type: "report-declarationType",
  },
  {
    title: "블라인드",
    type: "report-delete",
  },
];

export const report_layouts = [
  {
    title: "영리목적/홍보성",
    index: "01",
  },
  {
    title: "불법정보",
    index: "02",
  },
  {
    title: "음란성/선정성",
    index: "03",
  },
  {
    title: "욕설/인신공격",
    index: "04",
  },
  {
    title: "개인정보노출",
    index: "05",
  },
  {
    title: "도배",
    index: "06",
  },
  {
    title: "기타",
    index: "07",
  },
];
